<template>
  <div>
    <div v-if="!scrollingActive" class="cta_sticky">
    <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBsankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-18 ls-1 mt-2">Find an alternative to  {{provider.name}}</a>
  </div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>
    
  <app-hero-section :urlBackground="urlBackground" :herotype="herotype"></app-hero-section> 

  </header>

  

  <main ref="main">
    <aside v-if="!scrollingActive" class="mb-4">
      <div class="aside_widget monito_score pl-0 pr-0">
        <widget-monito-score :provider="provider"></widget-monito-score>
      </div>
      <monito-widgets-imt-search-form v-if="false" powered-by-nf="off" country-from="US" title="It's a title" country-to="PH"></monito-widgets-imt-search-form>
       <div v-if="false" class="aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14">
        <div class="should excellent">
          <p><span>What you should do</span><b>Make sure it's the ideal provider for your transfer, make a comparison</b> Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.</p>
          <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Compare the providers</a>
        </div>
        </div>
    </aside>
    <div class="left_content" style="display: inline-block; margin-right: 26px; vertical-align: top;">
        <section class="has-cover
          boxed
          pt-2 pl-7 pr-7 pb-10
          pl-lg-5 pr-lg-5 pb-lg-8
          pl-md-5 pr-md-5 pb-md-8
          pl-sm-8_p pr-sm-8_p pb-sm-7">
          <div class="cover" style="background-image: url('https://images.prismic.io/monito/ca011fe5e686e44d279849ebc19f07b5e545e35f_paypal-homepage-laptop.png?auto=compress,format')"></div>

        <h1 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Monito's review of {{provider.name}} on their Exchange Rates & Fees Calculator</h1>
        
        <widget-author class="mb-2 mt-3">
          <div class="portrait">
            <span class="image" style="background-image:url('https://images.prismic.io/monito/aef881966e4f5bbc8a5ffc79819720e3a733b1c9_laurent.png');"></span>
            <p class="name pt-sm-2"><span>Written by</span><a href="https://www.monito.com/en/wiki/why-you-can-trust-monito#section0?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content">Laurent Oberholzer</a></p>
            <p class="pb-sm-3 update"><span>Last updated</span>May 11, 2020</p>
          </div>
          <p class="bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti">Co-Founder and Head of Business Development at Monito. He is a recognized expert with over six years of experience in the banking and money transfer industry.</p>
        </widget-author>
        <widget-breadcrum>
          <a>Home</a><span>></span><a>Money Transfer Provider Reviews</a><span>></span><span class="active">{{provider.name}} Review</span>
        </widget-breadcrum>
        <p class="f_chapo"><a target="_blank" href="https://go.monito.com/transferwise">TransferWise</a> is a great money transfer service recommended by Monito. With more than 7 million customers and 50,000 positive customer reviews, we rate them 9.8/10 on “Trust and Credibility”, 9.5/10 on “Service Quality”, 9.0/10 on “Customer Satisfaction” and 9.5 /10 on “Fees & Exchange rates”. </p>

        <p class="f_body">TransferWise is an innovative international money transfer provider that is often dubbed the “Robin Hood” of the money transfer industry.</p>

        <p class="f_body">They focus on making bank transfers more affordable than traditional banks by charging low and transparent transfer fees and converting money at the true mid-market exchange rate. </p>
        <p class="f_body">In other words, there’s zero markup on the exchange rate. (As a comparison, banks usually give customers an above-market rate, the margin is part of their fees and in general, they are not transparent about this.)</p>
        <p class="f_body">TransferWise mobile apps have great ratings on Apple’s App Store (4.7/5 stars on 19,300 ratings) and Google’s Play Store (4.4/5 on almost 80,000 ratings). According to TransferWise customers, the app is "an invaluable tool for anyone moving money internationally".</p>
        <p class="f_body">They’ve seen massive growth since 2011 and are an extremely competitive, high-profile disruptor of the traditional money transfer model. TransferWise is frequently referred to as a no-nonsense company that is sparking a revolution.</p>
        <div v-if="scrollingActive" class="friendly mt-8 mb-5">
          <h2 class="fs-20 fw-bold">Our friendly recommendation</h2>
          <p class="f_body"><b>TransferWise is great,</b> but it's good to compare all the providers before each transfer.</p>
          <p class="f_body"><a href="#">Our magnificent comparison page</a> is free and allows you to find the cheapest, fastest or highest ranked supplier for your needs in no time.</p>
        </div> 
        <h2 class="f_subtitle_2">What we like about TransferWise</h2>
        <ul class="f_body pros">
          <li>You get the true mid-market rate</li>
          <li>Low and transparent transfer fees</li>
          <li>Fantastic user experience</li>
          <li>Exceptional customer reviews on Trustpilot</li>
        </ul>
        <h2 class="f_subtitle_2">What we dislike about TransferWise</h2>
        <ul class="f_body cons"><li>You can only send to a bank account</li></ul>

         <p class="f_body"><a target="_blank" href="https://www.monito.com/en/send-money-with/transferwise-borderless">Click here to read our TransferWise Borderless Account & Card Review.</a></p>
    </section>
    </div>
    <aside v-if="scrollingActive">
      <div class="aside_widget monito_score pl-0 pr-0">
        <widget-monito-score :provider="provider"></widget-monito-score>
      </div>
      <monito-widgets-imt-search-form v-if="false" powered-by-nf="off" country-from="US" title="It's a title" country-to="PH"></monito-widgets-imt-search-form>
       <div v-if="false" class="aside_widget mt-4 mb-sm-0 pt-14 pl-14 pb-14 pr-14">
        <div class="should excellent">
          <p><span>What you should do</span><b>Make sure it's the ideal provider for your transfer, make a comparison</b> Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.</p>
          <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Compare the providers</a>
        </div>
        </div>
    </aside>    
  </main>
  
  <widget-detail-monito-score :details_monito_score="details_monito_score" :details_trust="details_trust" :details_service="details_service" :details_customer="details_customer" :details_fees="details_fees" :provider="provider" :small_fees="small_fees" :small_customer="small_customer" :small_service="small_service" :small_trust="small_trust":fees="fees" :customer="customer" :service="service" :trust="trust" :scrollingActive="scrollingActive"></widget-detail-monito-score>

  <div v-if="scrollingActive" class="container_layout">
    <div class="left_content" style="vertical-align: top;">
      <section id="anchor01" ref="anchor01" class="
        boxed
        pt-2 pl-7 pr-7 pb-10
        pl-lg-5 pr-lg-5 pb-lg-8
        pl-md-5 pr-md-5 pb-md-8
        pl-sm-3 pr-sm-3 pb-sm-7
        mb-5">
        <div class="color"></div>

        <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Trust & Credibility</h2>
        <div v-html="trust"></div>

      </section>

      <section id="anchor02" ref="anchor02" class="
        boxed
        pt-2 pl-7 pr-7 pb-10
        pl-lg-5 pr-lg-5 pb-lg-8
        pl-md-5 pr-md-5 pb-md-8
        pl-sm-3 pr-sm-3 pb-sm-7 
        mt-5 mb-5">
        <div class="color"></div>

        <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Service Quality</h2>
        <div v-html="service"></div>

      </section>

      <section class="
        boxed
        pt-2 pl-7 pr-7 pb-10
        pl-lg-5 pr-lg-5 pb-lg-8
        pl-md-5 pr-md-5 pb-md-8
        pl-sm-3 pr-sm-3 pb-sm-7 
        mt-5 mb-5" id="anchor03" ref="anchor03">
        <div class="color"></div>

        <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Customer satisfaction</h2>
        <div v-html="customer"></div>

      </section>

      <section class="
        boxed
        pt-2 pl-7 pr-7 pb-10
        pl-lg-5 pr-lg-5 pb-lg-8
        pl-md-5 pr-md-5 pb-md-8
        pl-sm-3 pr-sm-3 pb-sm-7 
        mt-5 mb-5" id="anchor04" ref="anchor04">
        <div class="color"></div>

        <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Fees & Exchange rates</h2>
        <div v-html="fees"></div>

      </section>
    </div>
    <aside v-if="scrollingActive">
      <div class="aside_widget monito_score mb-4 pl-0 pr-0">
        <widget-monito-score :provider="provider"></widget-monito-score>
      </div>
    </aside>
  </div>
    
  <widget-providers :providers="providers">
    <div style="width: 900px; margin-left: auto; margin-right: auto;">
     <h1 class="fs-28 lh-6 mb-1 mt-5
      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2
    " style="text-align: center; margin-left: auto; margin-right: auto;">Alternatives to {{provider.name}}</h1>
    <span style="text-align: center; margin-left: auto; margin-right: auto; opacity: 0.88; display: block;" class="fs-19 italic fs-sm-17 fw-demi-bold f-anti" >Make an informed decision by comparing all the best options</span></div>
  </widget-providers>

  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  import WidgetSliderMonitoScore from './WidgetSliderMonitoScore.vue'
  import WidgetDetailsMonitoScore from './WidgetDetailsMonitoScore.vue'
  import WidgetBreadcrum from './WidgetBreadcrum.vue'
  export default {
    data() {
      return {
        herotype :'contentpage',
        scrollingActive : true,
        anchor : '01',
        scroll_history : '0',
        scroll_direction : 'down',
        aside_stack : '',
        stick_pos:'1',
        stick_pos_1:'1',
        aside_state : '',
        aside_state_down : '',
        details_trust  : [
          {label: 'Monito’s background check', score: '6', infos : 'PayPal is one of the largest independent, publicly traded, consumer financial technology companies in the world. They passed our background check.'},
          {label: 'Number of positive reviews', score: '10', infos : 'PayPal has less than 1,500 positive customer reviews'},
          {label: 'Number of customers', score: '10', infos : 'PayPal has more than 200 million customers'}, 
          {label: 'Years in business', score: '10', infos : 'PayPal exists since 1998'}, 
          {label: 'Transparent pricing', score: '3', infos : 'Most of the cost of a transfer is hidden in the exchange rate margin and some fees are not explicitly communicated'}
        ],
        small_trust : '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC).</p>',
        trust : '<p class="f_body">Our users often ask us, is TransferWise safe? Like all companies listed on our site, they must meet strict criteria to make them safe and trustworthy in our eyes.</p><p class="f_body">TransferWise is a licensed Authorised Electronic Money Institution—which means they are regulated by the FCA (Financial Conduct Authority) and HMRC (Her Majesty\'s Revenue and Customs) in the United Kingdom (where its headquarters are located) as well as by a variety of other regulatory institutions in other countries. For example, TransferWise Ltd Australia is regulated by the Australian Securities and Investments Commission (ASIC). In the US, they are registered with the Financial Intelligence Unit (AUSTRAC) as money remitter TransferWise Inc. and are registered with the Financial Crimes Enforcement Network (FinCEN). TransferWise Inc is also licensed as a money transmitter in individual American states—in other words, they aresupervised by regulatory authorities in each of the states they operate in.</p><p class="f_body">They offer institutional grade security for their service and take preventative measures, such as 2-step login and verification procedures.</p><p class="f_body">As per FCA regulations, clients’ funds are held completely separate from TransferWise’s own business accounts, in so-called segregated accounts. Should the company have any financial difficulties, your money will be safe.</p><p class="f_body">TransferWise employs around 1000 people from over 60 nationalities across its nine offices around the world. Employees give the company close to 5 star rating on the employer review site Glassdoor, and describe the team as a “great company that is doing an awesome job” full of “smart and motivated people,” a company that is “super customer-focused” with an “excellent culture.” One employee wrote they are “Impressed by the professionalism everyone has, alongside an innate sense of trust and drive to achieve the mission”  and another said “The product is honest so there\'s no trying to cheat customers, it\'s work you can feel good about doing.“ Overall, it’s clear that employees love working there and that they feel that they are on a mission to make sending money as cheap and convenient as possible.</p><p class="f_body">TransferWise has raised over $396M dollars from major investors including Virgin Group / Sir Richard Branson, Andreessen Horowitz, IVP (Institutional Venture Partners), Max Levchin of PayPal, Sapphire and Seedcamp, which has helped the startup sustain its phenomenal growth. For example, in 2016 they saw a growth rate of approximately 150% and in the 2017 fiscal year their revenues more than doubled! Overall, the company reported revenues of £67 million (US $94 million) for 2017, and made an adjusted operating profit of £2 million.</p><p class="f_body">So, is TransferWise safe? Absolutely, we wouldn’t hesitate to trust them even with transfers of large amounts. In fact, we have used them ourselves for many of our own international payments.</p><p class="f_body">Authorised by the UK Financial Conduct Authority (FCA)</p><p class="f_body">Firm Reference : 900507</p>',

        details_service : [
          {label: 'Monito\'s Expert Analysis', score: '6', infos : 'Our user experience experts found quite a few elements that could be improve on PayPal\'s website to make it more intuitive.'},
          {label: 'International transfer to bank account', score: '4', infos : 'Getting money in and out of your PayPal account to a bank account is a bit tedious and transfer can be long'},
          {label: 'International transfer to cash pick-up', score: '', infos : 'PayPal doesn\'t offer cash pick-up service'},
          {label: 'International Airtime top-up', score: '', infos : 'PayPal doesn\'t offer airtime top-up services'},
          {label: 'Travel Card', score: '', infos : 'PayPal doesn\'t offer airtime top-up services'},
           {label: 'Multi-currency account', score: '3', infos : 'PayPal\'s ability to hold account in multiple currencies is limited and not convenient'},
        ],
        small_service : '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p>',
        service: '<p class="f_body">TransferWise currently supports sending money to 71 countries and sending money from 43 countries. The company covers 1000+ routes (country combinations) across 57 currencies, and they are also one of the few companies offering the true mid-market rate.</p><p class="f_body">Most currencies supported by TransferWise offer one option: a bank transfer from one bank to another. For some currencies, you can pay with debit and credit cards or use a SOFORT transfer option. Apple Pay or Android Pay is also available for certain currencies via TransferWise iOS and Android apps. In most cases, the recipient will get the money within one to two business days.</p><p class="f_body">TransferWise is a top choice for international money transfers. They are known for their great customer service, have excellent reviews on Trustpilot, and provide speedy transfers. And the cherry on the cake? They also provide spectacular user experience, from an easy sign-up process to efficient transfers, as evidenced in our <a target="_blank" href="https://www.monito.com/en/wiki/transferwise-usability-user-experience/">in-depth UX analysis of what first-time users think of TransferWise</a>. Some users were so impressed they thought it is too good to be true. Yes, it’s good, but it’s also true!</p>',

        details_customer : [
          {label: 'Customer review score', score: '1.4', infos : 'PayPal has 14% of 4 of 5 stars customer reviews'},
          {label: 'Recommendation success rate', score: '', infos : 'We don\'t track the number of users who make a transfer with PayPal'}
        ],
        small_customer : '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p>',
        customer : '<p class="f_body">TransferWise has excellent customer reviews on Trustpilot. Nearly 90% of the feedback rating the company 5 stars on 56,619 reviews. Here’s what some TransferWise customers say:</p><h3 class="f_subtitle_2">Positive</h3><ul class="f_body pros"><li>It works!!! Trustable.</li><li>It\'s wonderful: Fast, transparent, inexpensive.</li><li>Quick, simple easy to use, self-explanatory. It’s also safe and efficient.</li><li>Fast, simple, user-friendly and with no hidden fees!</li><li>Very good customer service, helpful and knowledgeable.</li></ul><h3 class="f_subtitle_2">Negative</h3><ul class="f_body cons"><li>Sometimes there is a delay</li><li>Some frustrations with the required documentation required to verify identities</li></ul>',

        details_fees : [
          {label: 'International transfer to bank account', score: '1', infos : 'PayPal is the cheapest option in only 1% of the searches and is never competitive'},
          {label: 'International transfer to cash pick-up', score: '', infos : 'PayPal doesn\'t offer cash pick-up services'},
          {label: 'Airtime top-up', score: '', infos : 'PayPal doesn\'t offer airtime top-up services'},
          {label: 'Travel Card', score: '', infos : 'PayPal doesn\'t offer travel card services'},
          {label: 'Multi-currency account', score: '', infos : 'PayPal doesn\'t Multi-currency account services'},
        ],
        small_fees : '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p>',

        fees : '<h3 class="f_subtitle_2">TransferWise Transfer fees</h3><p class="f_body">TransferWise fees are low and fully transparent. They charge a percent of the transfer amount, and a flat fee for certain transfer routes (country combinations). The minimum TransferWise fees and percent depend on the currencies you are sending from and to and certain currencies have variable fees depending on the total amount being sent.</p><p class="f_body">For example, from GBP (British Pound) to EUR (Euro), you will pay 0.35% of the transfer amount with a fee of £0.80. The reverse, EUR (Euro) to GBP (British costs 0.5% of the transfer amount with a flat fee of €2. Sending DKK (Danish Kroner), to Euros will cost you 0.5% of the transfer amount on the initial DKK 50,000 and 0.3% on anything over that amount.</p><h3 class="f_subtitle_2">TransferWise Exchange rate</h3><p class="f_body">TransferWise converts your money using the true mid-market rate when they receive and process your money. This means that the TransferWise exchange rate is the fairest, most accurate exchange rate you can hope for. Bonus: TransferWise will automatically lock the exchange rate for a specified time frame, from 24 hours for most countries, and 48 hours for several others and 72 hours for BRL (Brazilian Reals) so you’re not exposed to exchange rate fluctuations (they call this the “guaranteed rate” feature). This is one way to ensure that your recipient receives a specific amount. Caveat: your money must be received by TransferWise within the specified time frame, or else the exchange rate - and therefore also the amount received - will no longer be guaranteed.</p><h3 class="f_subtitle_2">Other fees</h3><p class="f_body">In most cases, TransferWise uses local accounts to collect and send funds. This means that there should be no fees charged by the sending or receiving banks, and no intermediary bank fees.</p><p class="f_body">If you’re paying by credit card, you will be charged a credit card fee of 0.3% - 2% depending on the currency you’re sending from and the type of credit card you are using. Debit card payments are free from certain currencies or incur a debit card fee of 0.15% - 2%.</p><p class="f_body">TransferWise sends certain currencies via the international SWIFT network, which most banks will charge a fee to receive. If you’re sending to these currencies, make sure you check with the receiving bank how much they charge for incoming SWIFT payments. TransferWise SWIFT currencies are: JPY (Japanese Yen) over 1 million and ZAR (South African Rand) or a USD transfer to a bank account outside of US, we send it to your recipient as a SWIFT transfer.</p><p class="f_body">TransferWise can also receive USD (US Dollars) via SWIFT. If you live in the US, you will not want to do this since your bank will likely charge you fees to make a SWIFT payment, and free or cheaper alternatives are available (domestic wire and ACH direct debit). You’ll only want to send USD to TransferWise via SWIFT if your payment is coming from outside the US.</p>',


        urlBackground :'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
        provider : {logo: '/public/review_paypal.png',url:'paypal.com',score:'3.9',name : 'PayPal', sub_score_01: '8.6', sub_score_02: '4.8', sub_score_03: '1.4', sub_score_04: '1.0', country: '<span>Available from the UK</span> and 25 other countries to 54 countries', country_score :' excellent', cost: 'Never the cheapest providers for <span>all searches</span> on Monito', cost_score :' bad'},
        providers : [
          { logo: '../public/review_ria.png',
            url:'https://www.monito.com/en/send-money-with/ria?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'5.8' },
          { logo: '../public/review_worldremit.png',
            url:'https://www.monito.com/en/send-money-with/worldremit?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.3' },
          { logo: '../public/review_paypal.png',  
            url:'https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'5.1' },
          { logo: '../public/review_remitly.png',
            url:'https://www.monito.com/en/send-money-with/remitly?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'7.6'},
          { logo: '../public/review_skrill.png',
            url:'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.9'},
            { logo: '../public/review_transfergo.png',
            url:'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.1'},
            { logo: '../public/review_western.png',
            url:'https://www.monito.com/en/send-money-with/skrill?utm_source=internal&utm_medium=internal&utm_campaign=ABTestVenmo&utm_content=provider_carousel',
            score:'8.3'}
        ]
      }
    },
    methods : {
      handleScroll(e) {
        if(window.innerWidth > 990){
          this.scrollingActive = true;
        } else {
          this.scrollingActive = false;
        } 

          let main = $("main").get(0);
          let aside = $("aside").get(0);
          console.log(aside.getBoundingClientRect().bottom);
          if( main.getBoundingClientRect().bottom > 100  && aside.getBoundingClientRect().bottom < -10){
            $(".cta_sticky").addClass('active');
            $(".cta_sticky").removeClass('remove');
          } else if($(".cta_sticky").hasClass('active')){
            $(".cta_sticky").addClass('remove');
            $(".cta_sticky").removeClass('active');
          }
        

        let anchor01 = $("#anchor01").get(0);
        let anchor02 = $("#anchor02").get(0);
        let anchor03 = $("#anchor03").get(0);
        let anchor04 = $("#anchor04").get(0);
        if(this.scrollingActive){
          if(anchor01.getBoundingClientRect().top < 200 & anchor01.getBoundingClientRect().bottom > 100) {
            $(".monito_score ul li").removeClass('active');
            $(".monito_score ul li:nth-child(1)").addClass('active');
          } else if(anchor02.getBoundingClientRect().top < 200 & anchor02.getBoundingClientRect().bottom > 100) {
            $(".monito_score ul li").removeClass('active');
            $(".monito_score ul li:nth-child(2)").addClass('active');
          } else if(anchor03.getBoundingClientRect().top < 200 & anchor03.getBoundingClientRect().bottom > 100) {
            $(".monito_score ul li").removeClass('active');
            $(".monito_score ul li:nth-child(3)").addClass('active');
          } else if(anchor04.getBoundingClientRect().top < 200 ) {
            $(".monito_score ul li").removeClass('active');
            $(".monito_score ul li:nth-child(4)").addClass('active');
          } else {
            $(".monito_score ul li").removeClass('active');
          }
        }

        if(this.scrollingActive){
        let element_aside = $("main aside");
        let aside = $("main aside").get(0);
        
            if(aside.getBoundingClientRect().height + 70 > window.innerHeight) {
              console.log(this.stick_pos);
            if (window.scrollY < this.prevScrollY) {
              this.stick_pos = this.scrollUpwards(this.stick_pos, element_aside);
            } else {
              this.stick_pos = this.scrollDownwards(this.stick_pos, element_aside);
            }
            this.prevScrollY = window.scrollY; 
          } else {
            element_aside.css("position", "sticky")
              .css("top", '50px')
              .css("bottom", '')
              .css("align-self", "flex-start");
          }
        }
        
        

        if(this.scrollingActive){
        let element_aside_1 = $(".container_layout aside");
        let aside_1 = $(".container_layout aside").get(0);
        
          if(aside_1.getBoundingClientRect().height + 70 > window.innerHeight) {
              console.log(this.stick_pos);
            if (window.scrollY < this.prevScrollY) {
              this.stick_pos_1 = this.scrollUpwards(this.stick_pos_1, element_aside_1);
            } else {
              this.stick_pos_1 = this.scrollDownwards(this.stick_pos_1, element_aside_1);
            }
            this.prevScrollY = window.scrollY; 
          } else {
            element_aside_1.css("position", "sticky")
              .css("top", '50px')
              .css("bottom", '')
              .css("align-self", "flex-start");
          }
        }
        


      },
      scrollDownwards(stick_pos, element_aside){
        if(stick_pos === -1) return stick_pos;
        // Figure out where the new window will be after scroll
        let aside = element_aside.get(0);
        let browser_bottom = window.innerHeight;
        let aside_bottom = aside.getBoundingClientRect().top + aside.offsetHeight;
        let belowAside = browser_bottom > aside_bottom;
        // If we are going below the element then we know we must stick
        // it to the bottom.
        if (belowAside){
          element_aside.css("position", "sticky")
            .css("top", 'auto')
            .css("bottom", '20px')
            .css("align-self", "flex-end");
          return -1;
        }
        // If it will still be above the bottom of the element, then we
        // must absolutely position it to its current position - if it already is absolutely positioned then we do    nothing
        if (stick_pos == 0) return stick_pos;
        
        // Undo the stick to the top
        // First get the current position
        // $("aside").css("position", "absolute")
        // .css("top", aside.offsetTop);
        element_aside
          .css("top", aside.offsetTop)
          .css("position", "absolute")
          .css("bottom", '')
          .css("right", '0')
          .css("align-self", "");
        return 0;
      },

      scrollUpwards(stick_pos, element_aside){
        if(stick_pos === 1) return stick_pos;
        // Figure out where the new window will be after scrol        let aboveAside = aside.getBoundingClientRect().top > 50;
        // If we are going above the element then we know we must sticks
        // it to the top
        if (aboveAside){
          element_aside.css("position", "sticky")
            .css("top", '50px')
            .css("bottom", '')
            .css("align-self", "flex-start");
          return 1;
        }
    
        if (stick_pos == 0) return stick_pos;
  
      // Undo the stick to the bottom
      // First get the current position
      element_aside
        .css("top", aside.offsetTop)
        .css("position", "absolute")
        .css("bottom", '')
        .css("right", '0')
        .css("align-self", "");
      return 0;
      },

    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor,
      'widget-monito-score' : WidgetSliderMonitoScore,
      'widget-detail-monito-score' : WidgetDetailsMonitoScore,
      'widget-breadcrum' : WidgetBreadcrum,
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
      this.handleScroll();
    }
  }
</script>

<style lang="scss">


  header .hero_element{
    margin-top: -202px!important;
    left: -2px;
  }

  .bg-transition {
    display: none;
  }

  main {
    display: flex;
    margin-top: -195px;
    position: relative;
    z-index: 1000;
  }

  aside {
    width: 352px;
    flex-shrink: 0;
    position: sticky;
  }

  .container_layout {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .main_widget {
    display: inline-block;
    vertical-align: top;
  }

  .monito_score.aside_widget {
    padding-left: 0!important;
    padding-right: 0!important;
  }

  .scroller {
    width: 352px;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    position: sticky;
    right: 0;
    top: 50px;
  }

  .cta_sticky {
    position: fixed;
    z-index: 100000; 
    top: -200px;
    width: 100%;
    height: 60px;

    &:before {
      width: 1100px;
      left: calc(((1100px - 100vw) / 2) * -1);
      position: absolute;
      background: #fff;
      top: -182px;
      content: '';
      height: 240px;
      box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.1);
      z-index: 100;
      border-radius: 150% / 95%;
    }

    a {
      padding: 22px 0;
      font-size: 18px;
      width: 80%;
      display: inline-block;
      position: relative;
      z-index: 1000;
      text-align: center;
      margin-left: 10%;
    }
    &.active {
      animation-name: anim_cta_sticky;
      animation-duration: 0.7s;
      animation-fill-mode: forwards;
    }

    &.remove {
      animation-name: anim_cta_sticky_remove;
      animation-duration: 0.7s;
      animation-fill-mode: forwards;
    }
  }

  @keyframes anim_cta_sticky {
    from {
      position: fixed;
      top: -200px;
    }

    to {
      position: fixed;
      top: 0px;
    }
  }

  @keyframes anim_cta_sticky_remove {
    to {
      position: fixed;
      top: -200px;
    }

    from {
      position: fixed;
      top: 0px;
    }
  }

  /*aside .aside_widget{
    clip-path: polygon(-10% -10%, 110% -10%, 100% 90%, 100% 96%, 50% 100%, 0 96%, 0 90%);
   
  }

  aside {
    filter: drop-shadow(0px 3px 12px rgba(0, 0, 0, 0.06)); 
  }*/



  @media ($tablet_paysage) {
    header .hero_element{
      margin-top: -142px!important;
    }
    .article_content {
      display: none;
    }
    body {
      width: 100%;
      overflow: scrollY;
    }

    .title {
      width: 90%;
      margin-left: 5%;
      > div {
        width: 100%!important;
      }
    }

      .left_content {
        width: 100%!important;
        margin-right: 0!important;
        > section {
          width: 92%;
          margin-left: 4%;
          margin-right: 4%;
        }
      }

      .container_layout {
        width: 100%;
        display: block;
      }

    main {
      width: 100%;
    
      
      header .hero_element {
        margin-top: -242px!important;
      }

    }

    @media ($mobile) {
      main {
        display: block;
        margin-top: -112px;

        

        .boxed {
          border-radius: 12px;
          .cover {
            border-radius: 12px 12px 0 0;

          }
          h1 {
            text-align: center;
          }
        }

        aside, .left_content {
          width: 100%;
          display: block;
        }

        aside {
          position: relative!important;
          width: 92%;
          top: 0!important;
          margin-left: 4%;
          margin-right: 4%;
        }
      }
    }

    .scroller {
      width: 90%;
      margin-left: 5%;
      position: relative!important;
      top: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ReviewPaypal.vue